var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#C6F2BB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.7458,
    stroke: "#55C639",
    strokeOpacity: 0.1,
    strokeWidth: 1.50842
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9837 18.131L22.0892 16.6426C21.8912 16.318 21.7171 15.6926 21.7171 15.3126V13.8322C21.7171 10.9585 19.3817 8.62305 16.5158 8.62305C13.6421 8.63096 11.3067 10.9585 11.3067 13.8322V15.3047C11.3067 15.6847 11.1325 16.3101 10.9425 16.6347L10.0479 18.123C9.7075 18.701 9.62833 19.358 9.84208 19.928C10.0558 20.506 10.5387 20.9651 11.1721 21.171C12.0271 21.456 12.89 21.6618 13.7687 21.8122C13.8558 21.828 13.9429 21.836 14.03 21.8518C14.1408 21.8676 14.2596 21.8835 14.3783 21.8993C14.5842 21.931 14.79 21.9547 15.0037 21.9705C15.5025 22.018 16.0092 22.0418 16.5158 22.0418C17.0146 22.0418 17.5133 22.018 18.0042 21.9705C18.1862 21.9547 18.3683 21.9389 18.5425 21.9151C18.685 21.8993 18.8275 21.8835 18.97 21.8597C19.0571 21.8518 19.1442 21.836 19.2312 21.8201C20.1179 21.6776 20.9967 21.456 21.8517 21.171C22.4612 20.9651 22.9283 20.506 23.15 19.9201C23.3717 19.3264 23.3083 18.6772 22.9837 18.131ZM17.0937 14.9168C17.0937 15.2493 16.8246 15.5185 16.4921 15.5185C16.1596 15.5185 15.8904 15.2493 15.8904 14.9168V12.4626C15.8904 12.1301 16.1596 11.861 16.4921 11.861C16.8246 11.861 17.0937 12.1301 17.0937 12.4626V14.9168Z",
    fill: "#55C639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7404 22.8409C18.4079 23.7593 17.5291 24.4163 16.5 24.4163C15.8745 24.4163 15.257 24.163 14.8216 23.7118C14.5683 23.4743 14.3783 23.1576 14.2675 22.833C14.3704 22.8488 14.4733 22.8568 14.5841 22.8726C14.7662 22.8963 14.9562 22.9201 15.1462 22.9359C15.5975 22.9755 16.0566 22.9993 16.5158 22.9993C16.967 22.9993 17.4183 22.9755 17.8616 22.9359C18.0279 22.9201 18.1941 22.9122 18.3525 22.8884C18.4791 22.8726 18.6058 22.8568 18.7404 22.8409Z",
    fill: "#55C639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBell);
export default __webpack_public_path__ + "static/media/greenBell.e4120c77615621d2abee379cbcead0ad.svg";
export { ForwardRef as ReactComponent };